// extracted by mini-css-extract-plugin
module.exports = {"form-body":"HotelSearch_form-body__l9uWZ","search-button":"HotelSearch_search-button__2mfim","search-button--error":"HotelSearch_search-button--error__ObE6T"};